export const firebase = {
  "parm": {
    "apiKey": "AIzaSyAXnD8jB9Wizj8zADPdYjZ51FpyVD4JuGE",
    "storageBucket": "com-f5-parm.appspot.com",
    "measurementId": "G-K9H3K53LJ7",
    "messagingSenderId": "868795766038",
    "databaseURL": "https://com-f5-parm.firebaseio.com",
    "appId": "1:868795766038:web:5f96263be208891726ac37",
    "projectId": "com-f5-parm",
    "authDomain": "com-f5-parm.firebaseapp.com"
  },
  "default": {
    "messagingSenderId": "171315357154",
    "storageBucket": "parm-names-not-numbers.appspot.com",
    "apiKey": "AIzaSyBOYnOzGtGpgvUOl5TGr-BA1Ut1i5rtjLo",
    "measurementId": "G-82KFXEBDJV",
    "appId": "1:171315357154:web:2d133f7a25d9ae1ffa05bb",
    "databaseURL": "https://parm-names-not-numbers.firebaseio.com",
    "projectId": "parm-names-not-numbers",
    "authDomain": "parm-names-not-numbers.firebaseapp.com"
  }
};